import React from 'react';
import { getContext } from 'common';

import Styled from './styles';

export interface StepConfigurationAreaProps {
  /** Configuration area components.  */
  children?: React.ReactNode;
}


/** `StepConfigurationArea`, all other props will be provided to the root component.` */
const StepConfigurationArea = React.forwardRef<HTMLElement, StepConfigurationAreaProps>((props: StepConfigurationAreaProps, ref) => getContext(({ RTL }) => {
  const { children, ...otherProps } = props;
  return (
    <Styled.StepConfigurationArea
      ref={ref}
      rtl={RTL}
      {...otherProps}
    >
      {children}
    </Styled.StepConfigurationArea>
  );
}));

StepConfigurationArea.defaultProps = {
  children: undefined,
};

StepConfigurationArea.displayName = 'StepConfigurationArea';

export default StepConfigurationArea;